import type { BookingConfirmationInsurance } from '@massilia/queries'

import { ExternalLink, Shield } from 'lucide-react'

import { centsToEuros, formatPrice } from '@/utils/format-price'

interface InsuranceSectionProps {
  insurance: BookingConfirmationInsurance
}

export function InsuranceSection({ insurance }: InsuranceSectionProps) {
  return (
    <div className="border-gray-light-200 flex flex-col gap-3 rounded-2xl border bg-white p-6">
      <div className="text-gray-light-900 text-lg leading-7 font-semibold sm:text-2xl">
        Assurance voyage
      </div>

      <div className="border-gray-light-200 flex flex-col gap-4 rounded-xl border p-4">
        <div className="flex items-center gap-3">
          <div className="bg-brand-50 flex size-9 items-center justify-center rounded-lg">
            <Shield className="text-brand-600 size-5" />
          </div>
          <div className="flex flex-col">
            {insurance.nomAssurance && (
              <span className="text-gray-light-900 text-sm font-semibold">
                {insurance.nomAssurance}
              </span>
            )}
            {insurance.nomFormule && (
              <span className="text-gray-light-600 text-xs font-medium">
                {insurance.nomFormule}
              </span>
            )}
          </div>
        </div>

        <div className="flex items-start justify-between gap-3 text-sm">
          <span className="text-gray-light-700 font-medium">Prix</span>
          <span className="text-gray-light-900 font-semibold">
            {formatPrice(centsToEuros(insurance.price))}
          </span>
        </div>

        {insurance.dinLink && (
          <div className="flex flex-wrap gap-3">
            <a
              className="text-brand-600 hover:text-brand-700 flex items-center gap-1 text-xs font-medium"
              href={insurance.dinLink}
              rel="noopener noreferrer"
              target="_blank"
            >
              Documents d&apos;informations <ExternalLink className="size-3" />
            </a>
          </div>
        )}
      </div>
    </div>
  )
}
